import * as React from "react";
import { Flex, Layout, TagLabel, Text, useLocalVariant } from "@draftkings/arena-web";
import { mapCombinationStatusToVariant } from "../_localVariants";
export const Combination = React.memo(function Combination(props) {
    const { id, returns, selectionsMapped, } = props;
    const combinationStatusTagsVariant = useLocalVariant("layout", {
        root: {
            flex: "1 1 auto",
        },
        firstChild: {
            borderTopLeftRadius: "$s0",
            borderBottomLeftRadius: "$s0",
        },
        lastChild: {
            borderTopRightRadius: "$s0",
            borderBottomRightRadius: "$s0",
        },
    });
    return (React.createElement(Flex, { as: "li", marginBottom: "$s1" },
        React.createElement(Layout, { variant: combinationStatusTagsVariant }, selectionsMapped.map(mappedSelection => React.createElement(TagLabel, { testId: `combination-${id}-tag-${mappedSelection.id}`, as: "span", variant: mapCombinationStatusToVariant[mappedSelection.status], key: mappedSelection.id }, mappedSelection.id))),
        React.createElement(Text, { testId: `combination-returns-${id}` }, returns)));
});
//# sourceMappingURL=Combination.js.map